<form #form="ngForm" (ngSubmit)="form.valid && submit()" novalidate>
    <div class="modal-header">
        <h1 class="modal-title font-size-1-75" id="modal-page-fix-title" translate [translate-args]="{misspelling: misspelling.toString()}">
            Use PageCorrect to correct the following misspelling:<code>[[misspelling]]</code>
        </h1>
    </div>
    <div class="modal-body bg-white page-fix-form-fix" id="modal-page-fix">
        <div class="bg-light-grey d-flex align-items-stretch img-rounded mb-3 px-4 py-4">
            <div class="flex-fill">
                <div class="form-group row">
                    <label class="col-48 control-label" for="quickfix_other" translate>
                        Please insert the correct word:
                    </label>
                    <div class="col-auto flex-fill">
                        <input data-test="correct-misspelling-input" id="quickfix_other" class="form-control" type="text" required [(ngModel)]="correctSpelling" name="correctSpelling"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button data-test="cancel-button" class="btn btn-border-radius btn-secondary" type="button" (click)="cancel()" translate>
            Cancel
        </button>
        <button data-test="save-button" class="btn btn-border-radius btn-marine-blue ml-0" [disabled]="form.invalid" translate>Save</button>
    </div>
</form>
